<template>
  <div class="task-level" :style="{ color: itemLevelStyle.color, 'background-color': itemLevelStyle.bgColor }">
    {{ itemLevelStyle.otherName }}
  </div>
</template>
<script>
import { taskLevelMap } from "@/utils/const.js";
export default {
  props: ['level'],
  data() {
    return {
      taskLevelMap: taskLevelMap
    }
  },
  computed: {
    itemLevelStyle() {
      if(!this.level) return {}
      return this.taskLevelMap.find((res) => res.key === this.level || res.name === this.level);
    }
  }
}
</script>
<style lang="scss" scoped>
.task-level {
  font-size: 12px;
  text-align: center;
  border-radius: 2px;
  height: 18px;
  width: 18px;
  line-height: 18px;
  box-sizing: border-box;
}
</style>
